// German Beginner Vocabulary - 50 unique items
// Each item supports 3 question types: target↔english, definition→target (no romanization)

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const germanBeginnerItems: VocabularyItem[] = [
  // Greetings & Basic Phrases (1-10)
  {
    id: 'de-beg-001',
    target: 'Hallo',
    english: 'Hello',
    definition: 'A common informal greeting',
    partOfSpeech: 'interjection'
  },
  {
    id: 'de-beg-002',
    target: 'Guten Tag',
    english: 'Good day',
    definition: 'A formal daytime greeting',
    partOfSpeech: 'interjection'
  },
  {
    id: 'de-beg-003',
    target: 'Auf Wiedersehen',
    english: 'Goodbye',
    definition: 'A formal farewell expression',
    partOfSpeech: 'interjection'
  },
  {
    id: 'de-beg-004',
    target: 'Tschüss',
    english: 'Bye',
    definition: 'An informal farewell expression',
    partOfSpeech: 'interjection'
  },
  {
    id: 'de-beg-005',
    target: 'Danke',
    english: 'Thank you',
    definition: 'An expression of gratitude',
    partOfSpeech: 'interjection'
  },
  {
    id: 'de-beg-006',
    target: 'Bitte',
    english: 'Please / You\'re welcome',
    definition: 'A polite word for requests or responding to thanks',
    partOfSpeech: 'interjection'
  },
  {
    id: 'de-beg-007',
    target: 'Entschuldigung',
    english: 'Excuse me / Sorry',
    definition: 'An expression to apologize or get attention',
    partOfSpeech: 'interjection'
  },
  {
    id: 'de-beg-008',
    target: 'Guten Morgen',
    english: 'Good morning',
    definition: 'A morning greeting',
    partOfSpeech: 'interjection'
  },
  {
    id: 'de-beg-009',
    target: 'Guten Abend',
    english: 'Good evening',
    definition: 'An evening greeting',
    partOfSpeech: 'interjection'
  },
  {
    id: 'de-beg-010',
    target: 'Gute Nacht',
    english: 'Good night',
    definition: 'A nighttime farewell or bedtime greeting',
    partOfSpeech: 'interjection'
  },

  // Pronouns & People (11-20)
  {
    id: 'de-beg-011',
    target: 'ich',
    english: 'I',
    definition: 'First person singular pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'de-beg-012',
    target: 'du',
    english: 'you (informal)',
    definition: 'Second person singular informal pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'de-beg-013',
    target: 'er',
    english: 'he',
    definition: 'Third person singular masculine pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'de-beg-014',
    target: 'sie',
    english: 'she / they',
    definition: 'Third person singular feminine or plural pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'de-beg-015',
    target: 'wir',
    english: 'we',
    definition: 'First person plural pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'de-beg-016',
    target: 'der Freund',
    english: 'friend (male)',
    definition: 'A male person you know well and like',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-017',
    target: 'die Familie',
    english: 'family',
    definition: 'A group of related people',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-018',
    target: 'der Lehrer',
    english: 'teacher (male)',
    definition: 'A male person who teaches',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-019',
    target: 'der Schüler',
    english: 'student (male)',
    definition: 'A male person who studies at school',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-020',
    target: 'der Mensch',
    english: 'person / human',
    definition: 'A human being',
    partOfSpeech: 'noun'
  },

  // Numbers (21-30)
  {
    id: 'de-beg-021',
    target: 'eins',
    english: 'one',
    definition: 'The number 1',
    partOfSpeech: 'number'
  },
  {
    id: 'de-beg-022',
    target: 'zwei',
    english: 'two',
    definition: 'The number 2',
    partOfSpeech: 'number'
  },
  {
    id: 'de-beg-023',
    target: 'drei',
    english: 'three',
    definition: 'The number 3',
    partOfSpeech: 'number'
  },
  {
    id: 'de-beg-024',
    target: 'vier',
    english: 'four',
    definition: 'The number 4',
    partOfSpeech: 'number'
  },
  {
    id: 'de-beg-025',
    target: 'fünf',
    english: 'five',
    definition: 'The number 5',
    partOfSpeech: 'number'
  },
  {
    id: 'de-beg-026',
    target: 'sechs',
    english: 'six',
    definition: 'The number 6',
    partOfSpeech: 'number'
  },
  {
    id: 'de-beg-027',
    target: 'sieben',
    english: 'seven',
    definition: 'The number 7',
    partOfSpeech: 'number'
  },
  {
    id: 'de-beg-028',
    target: 'acht',
    english: 'eight',
    definition: 'The number 8',
    partOfSpeech: 'number'
  },
  {
    id: 'de-beg-029',
    target: 'neun',
    english: 'nine',
    definition: 'The number 9',
    partOfSpeech: 'number'
  },
  {
    id: 'de-beg-030',
    target: 'zehn',
    english: 'ten',
    definition: 'The number 10',
    partOfSpeech: 'number'
  },

  // Common Nouns (31-40)
  {
    id: 'de-beg-031',
    target: 'das Wasser',
    english: 'water',
    definition: 'Clear liquid essential for life',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-032',
    target: 'das Brot',
    english: 'bread',
    definition: 'A baked food made from flour',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-033',
    target: 'der Kaffee',
    english: 'coffee',
    definition: 'A hot beverage made from roasted beans',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-034',
    target: 'das Buch',
    english: 'book',
    definition: 'Written or printed pages bound together',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-035',
    target: 'das Haus',
    english: 'house',
    definition: 'A building where people live',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-036',
    target: 'die Katze',
    english: 'cat',
    definition: 'A small furry pet animal that meows',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-037',
    target: 'der Hund',
    english: 'dog',
    definition: 'A domesticated animal that barks',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-038',
    target: 'das Auto',
    english: 'car',
    definition: 'A wheeled vehicle for transportation',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-039',
    target: 'das Handy',
    english: 'mobile phone',
    definition: 'A portable telephone device',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-beg-040',
    target: 'das Geld',
    english: 'money',
    definition: 'Currency used to buy things',
    partOfSpeech: 'noun'
  },

  // Common Verbs & Actions (41-50)
  {
    id: 'de-beg-041',
    target: 'essen',
    english: 'to eat',
    definition: 'To consume food through the mouth',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-beg-042',
    target: 'trinken',
    english: 'to drink',
    definition: 'To consume liquids',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-beg-043',
    target: 'sehen',
    english: 'to see',
    definition: 'To perceive with the eyes',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-beg-044',
    target: 'hören',
    english: 'to hear',
    definition: 'To perceive sound with the ears',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-beg-045',
    target: 'sprechen',
    english: 'to speak',
    definition: 'To communicate using words',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-beg-046',
    target: 'lesen',
    english: 'to read',
    definition: 'To look at and understand written words',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-beg-047',
    target: 'schreiben',
    english: 'to write',
    definition: 'To form letters or words on a surface',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-beg-048',
    target: 'gehen',
    english: 'to go / to walk',
    definition: 'To move on foot or travel somewhere',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-beg-049',
    target: 'kommen',
    english: 'to come',
    definition: 'To move toward the speaker',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-beg-050',
    target: 'lieben',
    english: 'to love',
    definition: 'To have strong affection for someone',
    partOfSpeech: 'verb'
  }
];
